export default __webpack_public_path__ + "static/media/happy-monkey.014ad02b.gif";